/**
 * en-GB messages added by Phase 3 task S22 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s22EnGB = {
    'evacuation.error.bad_cidr': 'That is not a valid address or range (for example 203.0.113.7 or 203.0.113.0/24).',
    'evacuation.error.token_needs_cidrs': 'A panel that uses a token needs at least one address it may call from.',
    'evacuation.error.panel_name_taken': 'Another fire panel at this site already has that name.',
};
//# sourceMappingURL=s22.js.map